import { Request } from '~src/httpClient/serverApi/requests/Request';

import { IUploadReservation } from '../types/IBundleUpload';

/**
 * The VizPortal `beginUpload` Web Client method (WebClientContentMobilityAppService.beginUpload, CM
 * `createBundle`). Called at the start of an upload, before any bytes are sent: the service creates the
 * upload execution for the caller and returns the reserved bundle luid used for the rest of the flow
 * (trigger, cancel, and the later import). Takes no params — identity/site come from the actor.
 */
export class BeginBundleUploadRequest extends Request<{}, IUploadReservation> {
  constructor() {
    super('beginUpload', {});
  }
}
